export default {
    LOAD_CONTENTS (state, contents) {
        state.items = contents
    }
}